export default __webpack_public_path__ + "static/media/team7.b4543126.png";